<!--
 * @Descripttion: 
 * @version: 
 * @Author: FuDi
 * @Date: 2023-03-10 10:04:39
 * @LastEditTime: 2023-03-13 14:18:33
-->
<template>
  <div ref="wrapContent" >
    <div class="tsaPc">
      <div class="baseMain">
        <div class="baseTitle">
          <div class="titleCon">
            <img
                :src="logo"
                alt=""
            >
          </div>
        </div>
        <div class="baseContent">
          <div class="baseTop">
            <div class="title">企业实名资料完善</div>
            <div class="license_area">
              <input
                  type="file"
                  class="uploadfile"
                  ref="inputer"
                  @change="chooseFile"
              />
              <img v-if="usccUrl" :src="usccUrl" alt=""/>
              <img
                  v-else
                  src="@/assets/images/realName/enterPrise.png"
                  alt=""
              />
            </div>
            <div class="licenseBot">
              <p>认证资料(*请上传彩色原件或加盖公章的复印件)</p>
              <span>格式要求：原件照片、扫描件、支持jpg、jpeg、png、bmp格式照片，大小不超过10M</span>
            </div>
          </div>
          <el-form
              :model="form"
              :rules="applyrules"
              ref="applyForm"
              label-width="170px"
              class="demo-ruleForm"
          >

            <div class="formInfo formInfo1">
              <el-form-item
                  label="企业名称"
                  prop="name1"
              >
                <el-input
                    v-model="form.name1"
                    placeholder="请输入企业名称"
                    disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="统一社会信用代码"
                  prop="name2"
              >
                <el-input
                    v-model="form.name2"
                    placeholder="请输入统一社会信用代码"
                    disabled
                ></el-input>
              </el-form-item>
            </div>

            <div class="formInfo ">
              <div class="formTitle">法定代表人信息</div>
              <el-form-item
                  label="法定代表人姓名"
                  prop="legal"
              >
                <el-input
                    v-model="form.legal"
                    placeholder="请输入法定代表人姓名"
                    @input="$forceUpdate"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="法定代表人身份证号码"
                  prop="idCard"
              >
                <el-input
                    v-model="form.idCard"
                    placeholder="请输入法定代表人身份证号码"
                ></el-input>
              </el-form-item>
            </div>

            <div class="formInfo ">
              <div class="formTitle">银行开户信息</div>
              <el-form-item
                  label="企业开户名称"
                  prop="name3"
              >
                <el-input
                    v-model="form.name3"
                    placeholder="请输入企业开户名称"
                    maxlength="50"

                    disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="企业开户银行"
                  prop="bankName"
              >
                <el-input
                    v-model="form.bankName"
                    maxlength="50"
                    placeholder="请输入企业开户银行"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="企业开户账号"
                  prop="bankNo"
              >
                <el-input
                    v-model="form.bankNo"
                    maxlength="50"

                    placeholder="请输入企业开户账号"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="开户支行名称"
                  prop="bankSubbranch"
              >
                <el-input
                    v-model="form.bankSubbranch"
                    maxlength="50"
                    placeholder="请输入开户支行名称"
                ></el-input>
              </el-form-item>

            </div>
            <div class="formInfo ">
              <div class="formTitle">联系人信息</div>
              <el-form-item
                  label="联系人姓名"
                  prop="contactsName"
              >
                <el-input
                    v-model="form.contactsName"
                    placeholder="请输入联系人姓名"
                    maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="联系人手机号"
                  prop="contactsPhone"
              >
                <el-input
                    v-model="form.contactsPhone"
                    placeholder="请输入联系人手机号"
                ></el-input>
              </el-form-item>
              

              <el-form-item
                  label="验证码"
                  prop="contactsVerifyCode"
              >
                <el-input
                    v-model="form.contactsVerifyCode"
                    placeholder="请输入验证码"
                    class="codeText"
                >
                  <template slot="append">
                    <el-button
                        :disabled="disabled"
                        @click="getVerificationCode"
                    >{{ yzmtext }}
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item
                  label="联系人身份证号码"
                  prop="contactsIdCard"
              >
                <el-input
                    v-model="form.contactsIdCard"
                    placeholder="请输入联系人身份证号码"
                ></el-input>
              </el-form-item>
              <el-form-item
                  label="联系人身份证照片"
                  prop="viewUrl"
              >
                <div class="uploadCol">
                  <div class="idCard">
                    <div class="box">
                      <div class="up_area">
                        <input
                            type="file"
                            class="uploadfile"
                            ref="idcard_front"
                            @change="chooseIdCard(0)"
                        />
                        <img
                            style="width:auto;height:auto;max-width:100%;max-height:100%"
                            v-if="idcard_front_viewUrl"
                            :src="idcard_front_viewUrl"
                            alt=""
                        >
                        <img
                            v-else
                            src="@/assets/images/realName/idcard_front.png"
                            alt=""
                        >
                      </div>
                      <div class="des">
                        <b>点击上传身份证人像面</b>
                        <p>（支持格式为png、jpg、jpeg，文件大小不超过10MB）</p>
                      </div>
                    </div>
                    <div class="box">
                      <div class="up_area">
                        <input
                            type="file"
                            class="uploadfile"
                            ref="idcard_tails"
                            @change="chooseIdCard(1)"
                        />
                        <img
                            style="width:auto;height:auto;max-width:100%;max-height:100%"
                            v-if="idcard_tails_viewUrl"
                            :src="idcard_tails_viewUrl"
                            alt=""
                        >
                        <img
                            v-else
                            src="@/assets/images/realName/idcard_tails.png"
                            alt=""
                        >
                      </div>
                      <div class="des">
                        <b>点击上传身份证国徽面</b>
                        <p>（支持格式为png、jpg、jpeg，文件大小不超过10MB）</p>
                      </div>
                    </div>
                  </div>

                </div>
              </el-form-item>
            </div>
            <el-form-item
                label-width="0"
                class="botBtn"
                v-show="!btnFix"
            >
              <el-button @click="goBack()"><img :src="rollback" alt="">
                返 回</el-button>
              <el-button @click="submitForm('applyForm',1)">保 存</el-button>
              <el-button
                  type='primary'
                  :loading='isLoading'
                  @click="submitForm('applyForm',2)"
              >提 交
              </el-button>
            </el-form-item>

            <el-form-item
                label-width="0"
                class="botBtn btnFix"
                v-show="btnFix"
            >
              <el-button @click="goBack()"><img :src="rollback" alt="" >
                返 回</el-button>
              <el-button @click="submitForm('applyForm',1)">保 存</el-button>
              <el-button
                  type='primary'
                  :loading='isLoading'
                  @click="submitForm('applyForm',2)"
              >提 交
              </el-button>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </div>
    <div class="tsaMobile" style="position: absolute;height: 100%;width: 100%;overflow: auto">
            <Mobile />
    </div>

    <div class="zhe" v-if="progress">
      <div class="progress">
        <el-progress type="circle" :percentage="percentage"></el-progress>
      </div>
    </div>
    <div id="captcha-element"></div>
  </div>
  
</template>

<script>
import Mobile from "../h5";
import Upload from "@/components/Upload.vue";
import Methods from '../methods'
import NoTrace from '@/utils/noTrace';
export default {
  name: "index",
  components: {
    Mobile,
    Upload,
  },
  data() {
    let viewUrlPass = (rule, value, callback) => {
      if (!this.idcard_front_viewUrl) {
        callback(new Error("请上传身份证正面"));
      } else if (!this.idcard_tails_viewUrl) {
        callback(new Error("请上传身份证反面"));
      } else {
        callback();
      }
    };

    var space=(rule, value, callback) => {
      if (value.toString().replace(/\s/g,"")=='') {
        callback(new Error("输入内容不能全为空格"));
      }
      callback();
    };
    var checkFont=(rule, value, callback)=> {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('不能输入中文字符'));
        } else {
          callback();
        }
      }
      callback();
    }

    var vphone = (rule, value, callback) => {
      if (!/^1[23456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      }
      callback();
    };
    return {
      logo: require("@/assets/images/enterprise/enterLogo.png"),
      card1: require("@/assets/images/yyzzbg.png"),
      card2: require("@/assets/images/yyzzbg2.png"),
      rollback:require("@/assets/images/realName/rollback.png"),
      form: {
        contactsVerifyCode:''
      },
      applyrules: {
        legal: [
          {
            required: true,
            message: "请输入法定代表人姓名",
            trigger: "change",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入法定代表人身份证号码",
            trigger: "change",
          },
        ],
        bankName: [
          {
            required: true,
            message: "请输入企业开户银行",
            trigger: "change",
          },
        ],
        bankNo: [
          {
            required: true,
            message: "请输入企业开户账号",
            trigger: "change",
          },
        ],
        bankSubbranch: [
          {
            required: true,
            message: "请输入开户支行名称",
            trigger: "change",
          },
        ],
        contactsName: [
          {
            required: true,
            message: "请输入联系人姓名",
            trigger: "change",
          },
        ],
        contactsPhone: [
          {
            required: true,
            message: "请输入联系人手机号",
            trigger: "change",
          },
          { validator: vphone, trigger: "change" },
        ],
        contactsVerifyCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "change",
          },
        ],
        contactsIdCard: [
          {
            required: true,
            message: "请输入联系人身份证号码",
            trigger: "change",
          },
          { validator: space, trigger: "change" },
          { validator: checkFont, trigger: "blur" },
        ],
        name1: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "change",
          },
        ],
        name2: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change",
          },
        ],
        name3: [
          {
            required: true,
            message: "请输入企业开户名称",
            trigger: "change",
          },
        ],
        viewUrl: [
          {
            required: true,
            trigger: "change",
            validator: viewUrlPass,
          },
        ],
      },
      userInfo: {},
      imgs: {},
      imgLen: 0,
      objbg: {},

      idcard_front_viewUrl: "",
      idcard_tails_viewUrl: "",
      btnFix: false,
      flag: true,
      isLoading: false,
      yzmtext: "获取验证码",
      disabled: false,
      currentTime: 60,
      nvc: "",
      usccUrl: "",
      progress: false,
      percentage:0,
    };
  },
  computed: {
    ls() {
      return this.$route.query.ls ? true : false;
    },
  },
  methods:Methods,
  mounted() {
    this.identification();
    NoTrace.init('captcha-element', 'captcha-button')
    window.addEventListener('scroll', this.getScroll)
  },
  beforeDestroy() {
      NoTrace.reset()
  },

};
</script>

<style scoped lang='less'>

@media screen and (min-width: 769px) {
  @import "../css/pc.less";
}

@media screen and (max-width: 768px) {
  @import "../css/h5.less";
}
</style>